import { API } from "@/lib/api";
import { ReadStoreGroup, WriteStoreGroup } from "@/types/storeGroup";
import { APIService } from "@/services/api";

export const StoreGroupService = new APIService<
  ReadStoreGroup,
  WriteStoreGroup
>(API.StoreGroups);
